import { getRequestsByCommunityId } from '@/api/requests';
import { useQuery } from '@tanstack/react-query';
import { Box, Container, useTheme } from '@mui/material';

import type { Request } from '@/types/v2/request';
import { useUser } from '@/hooks/v2/use-user';

import { RequestsTable } from './components/requests-table';
import { CommunityPageHeader } from '@/components/common/community-page-header';
import { PaperPlaneTilt as PaperPlaneTiltIcon } from '@phosphor-icons/react/dist/ssr';
import { Seo } from '@/components/seo';

export default function RequestsPageV2() {
  const { community } = useUser();
  const theme = useTheme();
  const { data, isLoading, error } = useQuery<{ requests: Request[] }>({
    queryKey: ['requests', community?.id],
    queryFn: async () => {
      return await getRequestsByCommunityId(community?.id, {
        params: {
          sort: '-created_at',
          include: 'requestType,requestStatus,unit',
        },
      });
    },
  });

  return (
    <>
      <Seo title="Requests" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3,
          backgroundColor: theme.palette.background.default,
          minHeight: '100vh',
        }}
      >
        <Container maxWidth="xl">
          <CommunityPageHeader
            icon={<PaperPlaneTiltIcon size={36} />}
            subtitle="Manage requests from residents"
            title="Requests"
          />
          <RequestsTable error={error} loading={isLoading} rows={data?.requests || []} />
        </Container>
      </Box>
    </>
  );
}
